var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlossaryButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2727 9C9.56983 9 9 9.55965 9 10.25V34V36.5C9 37.8808 10.1396 39 11.5455 39H12.8138H12.8182H34.4545C35.8604 39 37 37.8808 37 36.5V12.75C37 12.0596 36.4302 11.5 35.7273 11.5H35V35.5C35 36.5 34.4545 37 33.5 37H12C11.5 37 11 36.5 11 36C11 35.5 11.5455 35 12 35H32C32.7029 35 33 34.6904 33 34V10.5C33 9.80965 32.2029 9 31.5 9H10.2727ZM18.3027 27.7338H24.6785L25.9027 31.3864H29.7694L23.1633 13.6591H19.7936L13.2239 31.3864H17.0906L18.3027 27.7338ZM23.6967 24.7751H19.2845L21.4784 18.1396L23.6967 24.7751Z",
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossaryButton);
export default __webpack_public_path__ + "static/media/glossary_Button.994f3537e6555c298a7e4d06ecd954f6.svg";
export { ForwardRef as ReactComponent };